import { axios, baseUrl, FTURL, JSONURL } from './config'
// import qs from 'qs'
const customEnvArr = ['dev', 'trial', 'prod']

export default {
  // 根据url获取微信配置信息
  weChatJssdk: (json) => axios.post(baseUrl + '/yzqapi/wx/conig', json),

  // 获取jwt  token
  getToken: (json) => axios.post(baseUrl + '/yzqapi/user/login', json),

  // 获取文章详情
  getDocumentDetailNew: (json) => axios.post(baseUrl + '/yzqapi/document/documentDetail', json),

  // 文章点赞
  postAddUpAmount: (json) => axios.post(baseUrl + '/yzqapi/document/addUpAmount', json),

  // 获取IM聊天记录
  chatRecord: (json) => axios.post(baseUrl + '/yzqapi/document/chatRecord', json),

  // 反垃圾 接口
  checkTextContent: (json) => axios.post(baseUrl + '/api/taboo/checkTextContent', json),

  // 获取IM签名
  getImSig: (json) => axios.post(baseUrl + '/yzqapi/document/generateUserSig', json),

  // 咨询收藏
  postDocumentCollect: (json) => axios.post(baseUrl + '/yzqapi/document/documentCollect', json),

  // 获取用户信息
  userInfo: (json) => axios.post(baseUrl + '/yzqapi/kyptCommon/getUserInfo', json),

  // 取消收藏
  C_batchDelete: (json) => axios.post(baseUrl + '/yzqapi/document/cancelDocumentCollect', json),

  // 获取预览内容
  preview: (json) => axios.get(baseUrl + '/yzqapi/document/common/preview', { params: json }),

  // 获取剩余预览时间
  remainTime: (json) => axios.get(baseUrl + '/yzqapi/document/preview/left', { params: json }),

  // 剩余预览次数
  scan: (json) => axios.get(baseUrl + '/yzqapi/document/qr/scan', { params: json }),

  // 获取专栏详情
  getColumnDetail: (json) => axios.post(baseUrl + '/yzqapi/columnist/queryColumnistDetail', json),

  // 关注专栏或取消专栏
  focusColumn: (json) => axios.post(baseUrl + '/yzqapi/kyptCommon/setFollows', json),

  // 获取专栏文章列表
  getColumnDocs: (json) => axios.post(baseUrl + '/yzqapi/document/documentQuery', json),

  // 获取专题详情
  getTopicDetail: (json) => axios.post(baseUrl + '/yzqapi/event/queryEventDetail', json),

  // 增加阅读量
  addReadNum: (json) => axios.post(baseUrl + '/yzqapi/document/addReadNum', json),

  // 获取多分辨率转码视频
  getMultiresolutionIndex: (json) => axios.post(FTURL + '/video/queryMultiresolutionIndex', json),

  // 获取分辨率的JSON配置
  getPlayBackJson: () => axios.get(JSONURL + '/kypt_muilti_video_basic_config', { isJson: true })
}
